import { FormGroup } from '@angular/forms';

export function extract(s: string) {
  return s;
}

export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors?.['mustMatch']) {
      return;
    }

    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}

export function restrictInputToAlphabet(charCode: any, event: any) {
  if (event?.metaKey || event?.ctrlKey) {
    return true;
  }

  if (event?.which === 32) {
    return false;
  }

  if (event?.which === 0) {
    return true;
  }

  if (event?.which < 33) {
    return true;
  }

  let input = String.fromCharCode(charCode);
  if (/[\d\s]/.test(input)) {
    return true
  }
  
  event.preventDefault();
  return false;
}